import type { API } from 'chessboard/api/config/types';
import JCE from '@chesscom/js-chess-engine';

/**
 * Create the getFingerprints method.
 */
export function createGetFingerprints(context: API.Context) {
  /**
   * Get the fingerprints of the current game.
   */
  return function getFingerprints(): JCE.GameFingerprints {
    return JCE.gameFingerprints({ game: context.game, analysis: true });
  };
}
